import Cookies from 'js-cookie';
import { getDictListByType } from '@/api/home';
import { getDictByTypeAsync } from '@/utils/cacheService';

const app = {
  state: {
    themeColor: '#FE5924',
    themeGreen: '#41B883',
    language: Cookies.get('language') || 'en_US',
    sidebar: {
      opened: Cookies.get('sidebarStatus') ? !!+Cookies.get('sidebarStatus') : true,
      withoutAnimation: false
    },
    device: 'desktop',
    realMobile: false,
    breadTitle: '',
    integralFeatureFlag: false,// 积分功能是否打开
    externalTransferFlag: false,// 外部转账功能是否打开
    smsVerificationEnabled: false,
    Privacy: 'https://maxain-bucket-prod.s3-accelerate.amazonaws.com/files/PrivacyPolicy.pdf',
    RiskStatement: 'https://maxain-bucket-prod.s3-accelerate.amazonaws.com/files/RiskDisclosureandWarningNotice.pdf',
    ToPreventMoneyLaundering: 'https://maxain-bucket-prod.s3-accelerate.amazonaws.com/files/AntiMoneyLaunderingAgreement.pdf',
    safety_instructions: 'https://maxain-bucket-prod.s3-accelerate.amazonaws.com/files/AccountFundsSecurityStatement.pdf',
    listRefresh: false,// 列表刷新
    websiteDomain: '',// worldpress官网,

    openAccountRole: '',// MAM主账户是4,MAM投资账户是5
  },
  mutations: {
    SET_LANGUAGE: (state, language) => {
      state.language = language;
      // cookie 持久化统一由 src/lang/index.js 的 setLocalePreference / writeCookie 负责
    },
    TOGGLE_SIDEBAR: state => {
      state.sidebar.opened = !state.sidebar.opened;
      state.sidebar.withoutAnimation = false;
      if (state.sidebar.opened) {
        Cookies.set('sidebarStatus', 1)
      } else {
        Cookies.set('sidebarStatus', 0)
      }
    },
    CLOSE_SIDEBAR: (state, withoutAnimation) => {
      Cookies.set('sidebarStatus', 0);
      state.sidebar.opened = false;
      state.sidebar.withoutAnimation = withoutAnimation;
    },
    TOGGLE_DEVICE: (state, device) => {
      state.device = device;
    },
    setMenuTitle: (state, title) => {
      state.breadTitle = title;
    },
    setRealMobile: (state, flag) => {
      state.realMobile = flag;
    },
    setListRefresh: (state, flag) => {
      state.listRefresh = flag;
    },
    setWebsiteDomain: (state, websiteDomain) => {
      state.websiteDomain = websiteDomain;
    },
    setIntegralFeatureFlag: (state, integralFeatureFlag) => {
      state.integralFeatureFlag = integralFeatureFlag;
    },
    setExternalTransferFlag: (state, externalTransferFlag) => {
      state.externalTransferFlag = externalTransferFlag;
    },
    setSmsVerificationEnabled: (state, smsVerificationEnabled) => {
      state.smsVerificationEnabled = smsVerificationEnabled;
    },
    setOpenAccountRole: (state, openAccountRole) => {
      state.openAccountRole = openAccountRole;
    },
  },
  actions: {
    setLanguage({ commit }, language) {
      commit('SET_LANGUAGE', language);
    },
    toggleSideBar({ commit }) {
      commit('TOGGLE_SIDEBAR')
    },
    closeSideBar({ commit }, { withoutAnimation }) {
      commit('CLOSE_SIDEBAR', withoutAnimation)
    },
    toggleDevice({ commit }, device) {
      commit('TOGGLE_DEVICE', device)
    },
    loadSmsVerificationEnabled({ commit }) {
      return getDictByTypeAsync(getDictListByType, 'smsOpen').then((data) => {
        const smsOpenConfig = Array.isArray(data) ? data[0] : null;
        commit('setSmsVerificationEnabled', String(smsOpenConfig && smsOpenConfig.value) === '1');
      }).catch(() => {
        commit('setSmsVerificationEnabled', false);
      });
    }
  },
  getters:{
    language: state => state.language,
    sidebar: state => state.sidebar,
    device: state => state.device,
    breadTitle: state => state.breadTitle,
    Privacy: state => state.Privacy,
    RiskStatement: state => state.RiskStatement,
    ToPreventMoneyLaundering: state => state.ToPreventMoneyLaundering,
    safety_instructions: state => state.safety_instructions,

    realMobile: state => state.realMobile,
    listRefresh: state => state.listRefresh,
    websiteDomain: state => state.websiteDomain,
    themeColor: state => state.themeColor,
    themeGreen: state => state.themeGreen,
    integralFeatureFlag: state => state.integralFeatureFlag,
    externalTransferFlag: state => state.externalTransferFlag,
    smsVerificationEnabled: state => state.smsVerificationEnabled,
    openAccountRole: state => state.openAccountRole,
  }
};

export default app;
